import React, { useEffect } from 'react';
import './InitialHome.css';
import Features from './Features';
import AboutUs from './AboutUs';
import ContactUs from './ContactUs';
import Footer from './Footer';
import { Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import AuthService from '../services/AuthService';

const InitialHome: React.FC = () => {

    const navigate = useNavigate();

    const logIn = () => {
        navigate('/login');
    }

    const register = () => {
        navigate('/register');
    }

    useEffect(() => {
        if (AuthService.isTokenExpired()) {
            AuthService.logout();
        }
    });

    return (
        <Box sx={{ color: 'text.primary' }} className='home'>
            <Box id="home-top" className="home-top home-section">
                <Box className="home-top-front">
                    <img src='logo.png' alt='Ontime Logo' />
                    <h1 style={{ display: "none" }}>Ontime Core</h1>
                    <h2>Appointment Scheduling System (Beta)</h2>
                    <Button variant="contained" onClick={logIn}>Login</Button>
                    <Button variant="contained" className="blink-button" sx={{ marginLeft: '5px' }} onClick={register}>Register Free</Button>
                </Box>
                {/* <Box className="home-top-back">
                    <img src='HomeBackShake.png' alt='Ontime Background Logo' />
                </Box> */}
            </Box>
            <Features />
            <AboutUs />
            <ContactUs />
            <Footer />
        </Box>
    );
};

export default InitialHome;